import React from 'react'
import { useInView } from 'react-intersection-observer'
import styled from '@emotion/styled'
import { Styles } from 'src/components/shared/CssValues'

const FadeDownWrap = ({ children }) => {
  const { ref, inView } = useInView({
    rootMargin: Styles.pc.inView,
    triggerOnce: true,
  });
 
  return (
    <FadeDown ref={ref} className={inView ? "-fadedown -show" : "-fadedown"}>
      {children}
    </FadeDown>
  )
}

const FadeDown = styled.div`
`


export default FadeDownWrap
